<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1><a routerLink="/fleet">Fleet</a> > <a routerLink="/vehicle/{{vehicle?.id}}">{{vehicle?.name}}</a> > Record maintenance</h1>
    </div>
  </div>
</div>

<form>
  <div class="form-group">
    @if (previousSuccess) {
      <div class="alert alert-dismissible alert-success">
        <button type="button" class="close" (click)="dismissSuccess()">&times;</button>
        <strong>Maintenance has been recorded.</strong> Feel free to record a new item.
      </div>
    }
  </div>
  <div class="form-group">
    <label for="item">Item*</label>
    <input type="text" class="form-control form-control-lg" [class.is-invalid]="item.invalid && (item.dirty || item.touched)"
      id="item" name="item" [(ngModel)]="maintenance.item" required maxlength="200" #item="ngModel" placeholder="Oil + filter"
      [ngbTypeahead]="maintenanceItemTypeahead">
    @if (item.invalid && (item.dirty || item.touched)) {
      <div class="invalid-feedback">
        @if (item.errors.required) {
          <div>Please enter a maintenance item, for example "Replaced retro-encabulator".</div>
        }
        @if (item.errors.maxlength) {
          <div>Please keep the item name brief. The Notes section below can hold more detail.</div>
        }
      </div>
    }
  </div>
  <div class="form-group">
    <label for="mileage">Mileage*</label>
    <div class="input-group">
      <input type="number" class="form-control form-control-lg" [class.is-invalid]="mileage.invalid && (mileage.dirty || mileage.touched)"
        id="mileage" name="mileage" [(ngModel)]="maintenance.mileage" required min="0" #mileage="ngModel" placeholder="102114">
      <div class="input-group-append">
        <div class="input-group-text">miles</div>
      </div>
      @if (mileage.invalid && (mileage.dirty || mileage.touched)) {
        <div class="invalid-feedback">
          @if (mileage.errors.required) {
            <div>Please enter the vehicle's mileage when the maintenance was performed as a number (ex. 98645).</div>
          }
        </div>
      }
    </div>
  </div>
  <div class="form-group">
    <label for="date">Date*</label>
    <input type="date" class="form-control form-control-lg" [class.is-invalid]="date.invalid && (date.dirty || date.touched)"
      id="date" name="date" [ngModel]="maintenance.date | date:'yyyy-MM-dd'" (ngModelChange)="maintenance.date=$event" required #date="ngModel" placeholder="2/4/92">
      @if (date.invalid && (date.dirty || date.touched)) {
        <div class="invalid-feedback">
          @if (date.errors.required) {
            <div>Please enter the date when the maintenance was performed.</div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="receipt">Receipt</label><br />
      <input type="file" id="receipt" name="receipt" (change)="newReceiptSelected($event)" #receiptInput style="display: none"/>
      @if (!maintenance.receipt) {
        <div>
          <div class="btn-group">
            @if (!uploading) {
              <button class="btn btn-info" (click)="openReceiptDialog()">Attach receipt</button>
            }
            @if (receipts?.length > 0) {
              <div ngbDropdown class="btn-group">
                <button class="btn btn-primary dropdown-toggle" id="receiptSelect" ngbDropdownToggle>Select existing</button>
                <div ngbDropdownMenu aria-labelledby="receiptSelect">
                  @for (receipt of receipts; track receipt) {
                    <button ngbDropdownItem (click)="existingReceiptSelected(receipt)">{{receipt}}</button>
                  }
                </div>
              </div>
            }
          </div>
          @if (uploading) {
            <ngb-progressbar type="info" [value]="uploadProgress" height="2rem">Uploading receipt...</ngb-progressbar>
          }
        </div>
      }
      @if (maintenance.receipt) {
        <div class="alert alert-dismissible alert-info">
          <button type="button" class="close" (click)="removeReceipt()">&times;</button>
          <strong>{{maintenance.receipt}}</strong> has been attached.
        </div>
      }
    </div>
    <div class="form-group">
      <label for="interval">Interval</label>
      <div class="input-group">
        <select class="form-control form-control-lg" id="intervalMonths" name="intervalMonths" [ngModel]="maintenance.intervalMonths" (ngModelChange)="maintenance.intervalMonths = $event ?? undefined">
          <option [ngValue]="undefined">Select time...</option>
          <option [ngValue]="3">3 months</option>
          <option [ngValue]="6">6 months</option>
          <option [ngValue]="9">9 months</option>
          <option [ngValue]="12">1 year</option>
          <option [ngValue]="24">2 years</option>
          <option [ngValue]="36">3 years</option>
          <option [ngValue]="60">5 years</option>
        </select>
        <div class="input-group-prepend input-group-append">
          <div class="input-group-text">or</div>
        </div>
        <input type="number" class="form-control form-control-lg" [class.is-invalid]="intervalMileage.invalid && (intervalMileage.dirty || intervalMileage.touched)"
          id="intervalMileage" name="intervalMileage" [ngModel]="maintenance.intervalMileage" (ngModelChange)="maintenance.intervalMileage = $event ?? undefined" #intervalMileage="ngModel" placeholder="10000">
        <div class="input-group-append">
          <div class="input-group-text">miles</div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="notes">Notes</label>
      <textarea class="form-control form-control-lg" id="notes" name="notes" [(ngModel)]="maintenance.notes" rows="3"></textarea>
    </div>
    <button (click)="add()" class="btn btn-primary" [disabled]="item.invalid || mileage.invalid || date.invalid || uploading">Submit</button>
    <button (click)="addAndContinue()" class="btn" [disabled]="item.invalid || mileage.invalid || date.invalid || uploading" title="Submit, then stay on this page to record more maintenance for this vehicle">
      Submit, and record more
    </button>
    <a routerLink="/vehicle/{{vehicle?.id}}" class="btn">Cancel</a>
  </form>